import * as React from "react";
import Avatar from "@mui/material/Avatar";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { User } from "../../types/User";
import { appendQueryParam, getFirstChar } from "../../util/helper";
import { deepOrange } from "@mui/material/colors";
import { Logout, StarRate, ManageAccounts } from '@mui/icons-material';
import { UserImageType } from "../../enum/user.type";

interface Props {
  user: User | null | undefined;
  cacheMetaData: any;
  isLoginVisible: boolean;
  onUpdateProfile: (user: User) => void;
  onLogout: () => void;
  onLogin: () => void;
  onNavigate: (path: string) => void;
}
export const AvatarBadge: React.FC<Props> = ({ user, cacheMetaData, isLoginVisible, onNavigate, onLogout, onUpdateProfile, onLogin }) => {
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const profilePic =  `${user ? appendQueryParam(user.images[UserImageType.Profile], 'updatedAt', user.updatedAt.toString()) : null}`;

  const downloadLocalStorage = (data: any, name: string) => {
    const jsonString = JSON.stringify(data, null, 2);
    // Create timestamp: YYYY-MM-DD_HH-MM-SS
    const now = new Date();
    const timestamp = now.toISOString().replace(/[:T]/g, "-").split(".")[0];
  
    const fileName = `${name}_${timestamp}.json`;
  
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
  
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
  
    URL.revokeObjectURL(url);
  }

  return (
    <Box sx={{ flexGrow: 0, marginLeft: 1 }}>
      {user ?
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Typography marginRight={1} variant="overline" color="white">{user.name}</Typography>
          <Avatar className="avatar" sx={{ bgcolor: deepOrange[500] }} src={profilePic}>{getFirstChar(user.name)}</Avatar>
        </IconButton> :
        <>{isLoginVisible ? <></> : <Button onClick={onLogin} sx={{ color: 'white' }}>Login</Button>}</>
      }

      {user && <Menu
        sx={{ mt: "45px" }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {user && <MenuItem onClick={() => {
          handleCloseUserMenu();
          onNavigate(`favourites`);
        }}>
          <StarRate />
          <Typography marginLeft={1} variant="subtitle2" textAlign="center">Favourites</Typography>
        </MenuItem>}

        <MenuItem onClick={() => {
          handleCloseUserMenu();
          onUpdateProfile(user);
        }}>
          <ManageAccounts />
          <Typography marginLeft={1} variant="subtitle2" textAlign="center">Account Settings</Typography>
        </MenuItem>

        <MenuItem onClick={() => {
          handleCloseUserMenu();
          onLogout();
        }}>
          <Logout />
          <Typography marginLeft={1} variant="subtitle2" textAlign="center">Logout</Typography>
        </MenuItem>
        <MenuItem onClick={() => {
          handleCloseUserMenu();
         
          const data: Record<string, string> = {};
          const keys = Object.keys(localStorage).sort();
          for (const key of keys) {
            data[key] = localStorage.getItem(key) ?? "";
          }

          downloadLocalStorage(data, 'localstorage');
          // downloadLocalStorage(cacheMetaData, 'cacheMetaData');

        }}>
          {/* <AppSettingsAlt /> */}
          <Typography marginLeft={1} variant="subtitle2" textAlign="center"></Typography>
          {/* <Typography marginLeft={1} variant="subtitle2" textAlign="center">Download System Cache</Typography> */}
        </MenuItem>
      </Menu>}
    </Box>
  );
};
